module.exports = __webpack_public_path__ + "img/Rewards.0d38f3a1.svg";